module.exports = __webpack_public_path__ + "static/media/billingIconHover.a609e0c6.svg";